const DotsSvg = () => <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="17.1299" cy="28.3067" r="5.87017" fill="white" />
  <circle cx="17.1299" cy="6.04692" r="5.87017" fill="white" />
  <circle cx="28.2598" cy="17.1767" r="5.87017" transform="rotate(-90 28.2598 17.1767)" fill="#FFC700" />
  <circle cx="6.00005" cy="17.1767" r="5.87017" transform="rotate(-90 6.00005 17.1767)" fill="white" />
</svg>
export default DotsSvg